import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { UrlSerializer } from '@angular/router';
import { provideDfNg } from '@df/ng/df-ng.providers';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NCore } from './df-core.interfaces';
import { DfUrlSerializer } from './meta/router/df-url-sanitizer';
import { StructuralDataService } from './meta/structural-data/structural-data.service';
import { StaleTabReloadService } from './service/stale-tab-reload/stale-tab-reload.service';
import { StylesService } from './service/styles';
import omit from 'lodash-es/omit';
import { getSiteId } from './util/get-site-id.fn';
import { WithStoreConfig } from './types';

export function provideDfCore(config?: WithStoreConfig<DeepPartial<NCore.IModuleOptions>>): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideDfNg(),
        { provide: UrlSerializer, useClass: DfUrlSerializer },
        {
            provide: NCore.OPTIONS,
            useFactory: () => {
                return defaultsDeep(config?.storeConfig?.[getSiteId()] || {}, omit(config, ['storeConfig']), NCore.DEFAULT_OPTIONS);
            }
        },
        provideAppInitializer(() => {
            inject(StylesService).appInitialize();
            inject(StructuralDataService).appInitialize();
            inject(StaleTabReloadService).appInitialize();
        })
    ]);
}
